module.exports = __webpack_public_path__ + "static/diema2-16db245601e9eba83e2aba19386f9b3e.png";